(() => {
  const root = window.Shopify?.routes?.root || '/';
  const toast = document.querySelector('[data-toast]');

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(window.__orivionToast);
    window.__orivionToast = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  const updateCartCount = async () => {
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
        const cartLink = node.closest('a[aria-label]');
        if (cartLink) cartLink.setAttribute('aria-label', `Cart with ${cart.item_count} items`);
      });
      document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { detail: { cart } }));
    } catch (_) {}
  };

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const closeMenu = () => {
    if (!menuButton || !mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    menuButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const willOpen = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', willOpen);
      menuButton.setAttribute('aria-expanded', String(willOpen));
      document.body.style.overflow = willOpen ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
  }

  const scrollMeter = document.querySelector('[data-scroll-meter]');
  const updateScrollMeter = () => {
    if (!scrollMeter) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    scrollMeter.style.width = `${max > 0 ? (window.scrollY / max) * 100 : 0}%`;
  };
  window.addEventListener('scroll', updateScrollMeter, { passive: true });
  updateScrollMeter();

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    document.querySelectorAll('.reveal').forEach((node) => observer.observe(node));
  } else {
    document.querySelectorAll('.reveal').forEach((node) => node.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step || 0));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const selector = productRoot.querySelector('[data-variant-select]');
    const price = productRoot.querySelector('[data-product-price]');
    const compare = productRoot.querySelector('[data-compare-price]');
    const submitButtons = productRoot.querySelectorAll('[data-add-to-cart]');
    const stickyVariant = productRoot.querySelector('[data-sticky-variant]');
    const stickyPrice = productRoot.querySelector('[data-sticky-price]');

    const applyVariant = () => {
      if (!selector) return;
      const option = selector.options[selector.selectedIndex];
      if (!option) return;
      if (price) price.textContent = option.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      submitButtons.forEach((button) => {
        button.disabled = option.dataset.available !== 'true';
        const label = button.querySelector('[data-button-label]');
        if (label) label.textContent = option.dataset.available === 'true' ? (button.dataset.availableLabel || 'Choose this essential') : 'Sold out';
      });
      if (stickyVariant) stickyVariant.value = option.value;
    };
    selector?.addEventListener('change', applyVariant);
    applyVariant();
  });

  document.querySelectorAll('form[data-ajax-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (form.dataset.ajax !== 'true') return;
      event.preventDefault();
      const button = form.querySelector('[data-add-to-cart]');
      const label = button?.querySelector('[data-button-label]');
      const original = label?.textContent;
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding…';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
        await updateCartCount();
        showToast('Added to your bag.');
      } catch (error) {
        showToast(error.message || 'Something went wrong.');
      } finally {
        const selector = form.querySelector('[data-variant-select]');
        const available = !selector || selector.selectedOptions[0]?.dataset.available === 'true';
        if (button) button.disabled = !available;
        if (label) label.textContent = available ? (original || button?.dataset.availableLabel || 'Choose this essential') : 'Sold out';
      }
    });
  });

  document.querySelectorAll('[data-sticky-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const mainForm = document.querySelector('form[data-ajax-product-form]');
      const mainButton = mainForm?.querySelector('[data-add-to-cart]');
      if (mainForm && mainButton && !mainButton.disabled) mainForm.requestSubmit(mainButton);
    });
  });

  // Delegation keeps the bundle button working after theme-editor section reloads.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('form[data-bundle-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-bundle-add]');
    if (!button || button.disabled || form.dataset.busy === 'true') return;
    const label = button.querySelector('[data-button-label]');
    const status = form.querySelector('[data-bundle-status]');
    const originalLabel = label?.textContent;
    const variants = [...form.querySelectorAll('[data-bundle-variant]')];
    const items = variants.map((input) => ({ id: input.value, quantity: 1 }));
    if (items.length !== 3 || items.some((item) => !/^\d+$/.test(item.id))) {
      if (status) status.textContent = 'This combination is unavailable. Please choose your tools individually.';
      return;
    }
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (label) label.textContent = 'Adding your three tools…';
    if (status) status.textContent = '';
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'We could not add the complete combination.');
      await updateCartCount();
      if (status) status.textContent = 'One roller, one brush and one mitt added. Review your bag for your total and automatic savings.';
      showToast('Your three-tool reset is in the bag.');
    } catch (error) {
      if (status) status.textContent = `${error.message || 'Something went wrong.'} Check your bag before trying again.`;
      await updateCartCount();
    } finally {
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
      button.disabled = false;
      if (label) label.textContent = originalLabel || 'Add all three & save';
    }
  });
})();
